var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFile = function SvgFile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 24"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "file_svg__a",
    d: "M0 0h17v17H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "transparent",
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.5 3.5)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "file_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#file_svg__a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M15.143 2.076A6.217 6.217 0 0 0 12.295.241C10.107-.414 7.77.286 6.167 2.076L1.392 7.413C.195 8.754-.28 10.72.162 12.55a5.5 5.5 0 0 0 1.23 2.388 4.657 4.657 0 0 0 2.136 1.376c.41.125.832.183 1.245.183 1.241-.004 2.454-.552 3.354-1.56l3.277-3.661c.8-.896 1.112-2.205.82-3.426a3.636 3.636 0 0 0-.82-1.59 3.082 3.082 0 0 0-1.426-.918c-1.092-.33-2.265.022-3.064.918L4.01 9.503l1.498 1.67L8.412 7.93a.985.985 0 0 1 1.02-.307c.365.111.65.427.747.837.1.41-.004.842-.273 1.14l-3.277 3.667c-.667.749-1.639 1.038-2.555.766-.915-.276-1.626-1.069-1.871-2.093-.245-1.02.02-2.108.687-2.856l4.77-5.333c1.073-1.198 2.627-1.666 4.09-1.225 1.461.437 2.602 1.711 2.991 3.342.394 1.635-.024 3.376-1.096 4.57l-4.37 4.887L10.77 17l4.374-4.887c1.602-1.795 2.229-4.41 1.643-6.856a7.352 7.352 0 0 0-1.643-3.18z",
    mask: "url(#file_svg__b)"
  })))));
};
export default SvgFile;